<template>
	<div class="login">
		<img src="../images/common/close.png" alt="" @click="close" class="close" />
		<div class="content">
			<div class="con_title">
				<p>亲爱的志愿者，欢迎登录</p>
				<p>- 登录后查看个人相关信息 -</p>
			</div>
			<el-input v-model="name" placeholder="请输入您的证件号" class="input-common" size="large">
				<img slot="prefix" :src="image1" alt="" class="image" />
			</el-input>
			<el-input placeholder="请输入密码" v-model="password" show-password class="input-common" size="large">
				<img slot="prefix" :src="image2" alt="" class="image" />
			</el-input>

			<div class="button submit" @click="login">登录</div>
			<!-- <div class="button register" @click="register">我要注册</div> -->
			<!-- <div class="bottom">
				<el-checkbox @change="onChange" :checked="checked" class="left">记住用户名</el-checkbox>
			</div> -->
			<div class="bottom">
				<div @click="gotoOrgAdd" style="visibility: hidden">组织入驻</div>
				<div class="right">
					<span @click="gotoForgot">忘记密码</span>|

					<span @click="gotoRegister">志愿者注册</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// import BackHome from '@/components/common/BackHome.vue'
import api from '@/assets/api.js'

export default {
	components: {
		// BackHome
	},
	data() {
		return {
			image1: require('@/images/common/login_card@2x.png'),
			image2: require('@/images/common/login_password@2x.png'),
			checked: false,
			name: '',
			password: '',
			loading: false
		}
	},
	created() {
		const userName = localStorage.getItem('jz_user')
		if (userName) {
			userName
			this.name = userName
			this.checked = true
		}
		// this.$EventBus.$emit('showMenu', false);
	},
	methods: {
		close() {
			this.$EventBus.$emit('hideLogin', '')
		},
		login() {
			if (!this.name) {
				this.$message.error('请输入您的证件号')
				return
			}
			if (!this.password) {
				this.$message.error('请输入密码')
				return
			}
			if (this.loading) return
			let that = this
			let params = {
				username: that.name,
				password: that.password
			}
			api.post('/api/volunteer/login.do', params).then(function (res) {
				let { data, errCode } = res
				if (errCode == '0000') {
					that.$EventBus.$emit('hideLogin', '')
					// console.log('登陆成功', res.data.token)
					localStorage.setItem('qz_zyz_token', res.data.token)
					that.getZyzid(res.data.token)
				} else {
					// that.loading = false
					that.$message.error(res.message)
				}
			})
		},

		gotoOrgAdd() {
			this.$router.push({ name: 'orgAdd' })
		},

		gotoRegister() {
			this.$EventBus.$emit('hideLogin', '')
			this.$router.push({ name: 'register' })
		},
		getZyzid(token) {
			let that = this
			api.post('/api/login/token/loginInfoByShareToken.do', {}, token).then(function (res) {
				let { data, errCode } = res
				if (errCode == '0000') {
					localStorage.setItem('qz_zyz_zyzid', res.userId)
					if (that.checked) {
						localStorage.setItem('qz_user', that.name)
					} else {
						localStorage.removeItem('qz_user')
					}
					that.$EventBus.$emit('hasLogin', '')
				} else {
					that.loading = false
				}
			})
		},

		register() {
			this.$router.replace({ name: 'register' })
		},
		onChange() {
			this.checked = !this.checked
		},
		gotoForgot() {
			this.$EventBus.$emit('hideLogin', '')
			this.$router.replace({ name: 'forgotPassword' })
		}
	}
}
</script>

<style lang="less" scoped>
.login {
	width: 500px;
	margin: 0 auto;
	margin-top: 200px;
	position: relative;
	.close {
		position: absolute;
		width: 20px;
		height: 20px;
		top: 20px;
		right: 20px;
		cursor: pointer;
	}

	.content {
		width: 400px;
		height: 380px;
		background-color: #ffffff;
		border-radius: 5px;
		padding: 30px 50px 20px;
		.con_title {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;

			p:nth-child(1) {
				font-size: 20px;
				line-height: 30px;
				font-weight: 600;
			}
			p:nth-child(2) {
				font-size: 16px;
				line-height: 47px;
				font-weight: 600;
			}
		}

		.image {
			width: 1.851vh;
			height: 1.851vh;
			margin-top: 1.2vh;
			object-fit: contain;
		}
		.input-common {
			margin-bottom: 20px;
			font-size: 14px;
			font-family: Helvetica;
			height: 36px;
		}

		.button {
			height: 50px;
			border-radius: 2px;
			margin-bottom: 20px;
			cursor: pointer;

			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 18px;
			font-family: Helvetica;
		}
		.submit {
			background: #de0617;
			color: #ffffff;
		}

		.bottom {
			display: flex;
			justify-content: space-between;
			align-items: center;
			.left {
				font-size: 14px;
				font-family: Helvetica;
				color: #727384;
			}
			.right {
				font-size: 14px;
				font-family: Helvetica;
				color: #000000;
				cursor: pointer;
				span:nth-child(1) {
					margin-right: 5px;
				}
				span:nth-child(2) {
					margin-left: 5px;
				}
			}
		}
	}
}
</style>
